import { DateTime } from "luxon";
import { AgGrid } from "@jsq/ds/core";
import Money from "../../../Money";
import { PayableRowItem } from "./types";

/**
 * List of the supported columns in the Payable table
 * (ordered from left to right)
 */
export enum SupportedColumns {
  Payee = "payee.name",
  Arena = "arena.name",
  Entity = "entity.name",
  Amount = "amount",
  InvoiceNumber = "invoiceNumber",
  CreatedDate = "createdAt",
  DueDate = "dueDate",
}

/**
 * The mapper provides the corresponding column name displayed in the table
 */
export const columnNames = new Map<SupportedColumns, string>([
  [SupportedColumns.Payee, "Payee"],
  [SupportedColumns.Arena, "Client"],
  [SupportedColumns.Entity, "Entity"],
  [SupportedColumns.Amount, "Amount"],
  [SupportedColumns.InvoiceNumber, "Invoice number"],
  [SupportedColumns.CreatedDate, "Created date"],
  [SupportedColumns.DueDate, "Due date"],
]);

/**
 * AG Grid Column definitions for the Payable Table
 * All columns have sortable: false as sorting is out of scope
 */
export const columnDefinitions: AgGrid.ColDef[] = [
  {
    field: SupportedColumns.Payee,
    headerName: columnNames.get(SupportedColumns.Payee),
    pinned: "left",
    minWidth: 360,
    sortable: false,
    resizable: false,
  },
  {
    field: SupportedColumns.Arena,
    headerName: columnNames.get(SupportedColumns.Arena),
    sortable: false,
    resizable: false,
  },
  {
    field: SupportedColumns.Entity,
    headerName: columnNames.get(SupportedColumns.Entity),
    sortable: false,
    resizable: false,
  },
  {
    field: SupportedColumns.Amount,
    headerName: columnNames.get(SupportedColumns.Amount),
    // type: DefaultColumnTypes.numericColumn,
    cellRenderer: Money,
    cellRendererParams: ({ data }: { data: PayableRowItem }) => ({
      money: data.amount,
      rounded: false,
    }),
    resizable: false,
  },
  {
    field: SupportedColumns.InvoiceNumber,
    headerName: columnNames.get(SupportedColumns.InvoiceNumber),
    sortable: false,
    resizable: false,
  },
  {
    field: SupportedColumns.CreatedDate,
    headerName: columnNames.get(SupportedColumns.CreatedDate),
    valueFormatter: ({ data }: { data: PayableRowItem }) => {
      return data.createdAt.toLocaleString(DateTime.DATE_MED);
    },
    sortable: false,
    resizable: false,
  },
  {
    field: SupportedColumns.DueDate,
    headerName: columnNames.get(SupportedColumns.DueDate),
    valueFormatter: ({ data }: { data: PayableRowItem }) => {
      return data.dueDate ? data.dueDate.toLocaleString(DateTime.DATE_MED) : "";
    },
    sortable: false,
    resizable: false,
  },
];
